const config = {
  api_url: process.env.REACT_APP_API_URL,
  host: process.env.REACT_APP_HOST_URL,
  wsHost: process.env.REACT_APP_WS_HOST_URL,
  appVersion: process.env.REACT_APP_VERSION
};

export default config;
